import React, { useState } from 'react'
import "./PartnerMangmentListing.css";
import { message, Table } from 'antd';
import { Link, Navigate } from 'react-router-dom';
import { DownloadOutlined, SaveOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Popconfirm } from 'antd';
import { Spin } from 'antd';
import { Dropdown } from 'antd';
import { Menu } from 'antd';
import { Payout_Service } from '../../../redux/Url';
import { connect } from 'react-redux';


const PayoutManagmentListing = (props) =>   {
  const {
    dataSource,
    pagination,
    onChange,
    loading,
    handelSubmit,
    downloading
  } = props;

  const [downloadingReportId, setDownloadingReportId] = useState(false);

  // Support both array and object with content property
  const tableData = Array.isArray(dataSource)
    ? dataSource
    : dataSource?.content || [];

  const mappedTableData = tableData.map((item, index) => ({
    ...item,
    "GeneratedDate": item.createdAt
      ? new Date(item.createdAt).toISOString().slice(0, 10)
      : '',
  }));

  // const handleFileDetails = (file) => {
  //   console.log("File Details Clicked:", file);
  //   Navigate(`/PayoutMakerDashBoard/PartnerPayout/generate-report/Details/${file.fileName}`, {
  //     state: { SelectedReportId: file.monthlyReportId },
  //   });
  // }


  const handleDownload = async (payoutgrp, fileType) => {
     try {
      setDownloadingReportId(true);
          const response = await fetch(
            // `http://localhost:8301/partner-payout-service/reports/download/partner?report_id=${ReportId}&approval_stage_id=${currentStage}&format=${format}`,
            `${Payout_Service}/reports/payout-lan-report-export/allPartners?lanTab=ALL&reportId=${payoutgrp.monthlyReportId}&format=${fileType}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + props.accessToken, // Use the access token from props
              },
            }
          );
          if (!response.ok) throw new Error('Network response was not ok');
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileType === 'csv' ? 'report.csv' : 'report.xlsx';
          document.body.appendChild(a);
          a.click();
          a.remove();
          message.success('Successfully downloaded the report');
          window.URL.revokeObjectURL(url);
        } catch (error) {
          message.error('Download failed:', error);
        } finally {
          setDownloadingReportId(false);
        }
  }


  const columns = [
    // {
    //   title: 'File Name',
    //   dataIndex: 'fileName',
    //   key: 'fileName',
    //   render: (_, payoutgrp) => (
    //     <Link to={`Details/${payoutgrp.fileName}/${payoutgrp.monthlyReportId}`} style={{ color: "#1b8593", textDecoration: 'none' }}>
    //       {payoutgrp.fileName}
    //     </Link>
    //   ),
    //   fixed: "left",
    // },
    {
    title: 'File Name',
    dataIndex: 'fileName',
    key: 'fileName',
    render: (_, payoutgrp) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Link
          to={`Details/${payoutgrp.fileName}/${payoutgrp.monthlyReportId}`}
          style={{ color: "#1b8593", textDecoration: 'none' }}
        >
          {payoutgrp.fileName}
        </Link>
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="csv" onClick={() => handleDownload(payoutgrp, 'csv')}>
                Download CSV
              </Menu.Item>
              <Menu.Item key="excel" onClick={() => handleDownload(payoutgrp, 'excel')}>
                Download Excel
              </Menu.Item>
            </Menu>
          }
          trigger={['click']}
        >
            <DownloadOutlined style={{ cursor: 'pointer', color: '#1b8593' }} />
        </Dropdown>
      </div>
    ),
    fixed: "left",
  },
    { title: 'Generated Date', dataIndex: 'createdAt', key: 'createdAt'
      , render: (text) => new Date(text).toLocaleDateString() },
    { title: 'User Name', dataIndex: 'userName', key: 'userName' },
    { title: 'Status', dataIndex: 'approvalStageName', key: 'approvalStageName' },
    { title: 'Partner Count', dataIndex: 'partnerCount', key: 'partnerCount' },
    { title: 'Records in File', dataIndex: 'recordsInFile', key: 'recordsInFile' },
    { title: 'Total Disb. Amount', dataIndex: 'totalDisbAmount', key: 'totalDisbAmount',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
     },
    { title: 'Gross Payout', dataIndex: 'grossPayout', key: 'grossPayout',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    { title: 'Payout on Hold', dataIndex: 'payoutOnHold', key: 'payoutOnHold',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    { title: 'Recovery Amount', dataIndex: 'recoveryAmount', key: 'recoveryAmount',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    { title: 'Retro Adj.', dataIndex: 'retroAdj', key: 'retroAdj',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    { title: 'Net Payout', dataIndex: 'netPayout', key: 'netPayout',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Action',
      dataIndex: 'operations',
      key: 'operations',
      render: (_, partner) => (
       
          <Button
            className='btn btn-primary'
            onClick={() => handelSubmit(partner.monthlyReportId)}
            disabled={partner.approvalStageId !== 1}
           style={{
                background: "#1b8593",
                color: '#fff',
                padding: '2px',
                borderRadius: '5px',
                textDecoration: 'none',
                minWidth: '200px',
                fontSize: '0.8rem',
              }}
          >
            <SaveOutlined /> {partner.approvalStageId !== 1 ? "Submited" : "Submit for Approval"}
          </Button>
   
        //  <Popconfirm
        //     title="Confirm Approval"
        //     description="Do you want to approve?"
        //     onConfirm={() => handelSubmit(partner.monthlyReportId)}
        //     // onCancel={cancel}
        //     okText="Yes"
        //     cancelText="No"
        //   >
            // <Button
            //   className='btn btn-primary'
            //   onClick={() => handelSubmit(partner.monthlyReportId)}
            //   disabled={partner.approvalStageId !== 2}
            // style={{
                  
            //       background: "#1b8593",
            //       color: '#fff',
            //       padding: '2px',
            //       borderRadius: '5px',
            //       textDecoration: 'none',
            //       minWidth: '200px',
            //       fontSize: '0.8rem',
            //       border: 'none', // Add this line to remove the border
            //       boxShadow: 'none', // Optional: remove any shadow
            //       // opacity: partner.approvalStageId !== 2 ? 0.6 : 1, // Optional: visual cue for disabled
            //       // cursor: partner.approvalStageId !== 2 ? 'not-allowed' : 'pointer', // Optional
            //     }}
            // >
            //   <SaveOutlined /> {partner.approvalStageId !== 2 ? "Approved" : "Approve"}
            // </Button>
          // </Popconfirm>
      ),
      fixed: "right",
      width: 70,
    },
  ];

  return (
    <div style={{ maxWidth: '100%' }}>
      {downloading || downloadingReportId && (
                    <div style={{
                      position: 'absolute',
                      zIndex: 10,
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: 'rgba(255,255,255,0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Spin tip="Loading..." size="large" />
                    </div>
                  )}
      <Table
        style={{ marginTop: "20px" }}
        dataSource={mappedTableData}
        columns={columns}
        scroll={{ x: "max-content" }}
        pagination={false}
        onChange={onChange}
        loading={loading}
        rowKey="fileName" // or another unique key
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps)(PayoutManagmentListing);